import { difference, map, xprod } from "ramda";

import { bathroomTiles } from "./patterns/bathroomTiles";
import { brickWall } from "./patterns/brickWall";
import { cerata } from "./patterns/cerata";
import { halfRombes } from "./patterns/halfRombes";
import { seigaiha } from "./patterns/seigaiha";
import { CardPattern, Color, colors, Pattern, patterns, PatternsMap, RoomType } from "./types";

const patternGenerator: PatternsMap = {
  "bathroom-tiles": (color: Color) => bathroomTiles(color),
  "brick-wall": (color: Color) => brickWall(color),
  cerata: (color: Color) => cerata(color),
  "half-rombes": (color: Color) => halfRombes(color),
  seigaiha: (color: Color) => seigaiha(color),
};

const getRandomListElement = <T>(list: T[]): T =>
  list[Math.floor(Math.random() * list.length)];

export const getPattern = (room: RoomType): CardPattern => {
  const cardPatterns = map<[Color, Pattern], CardPattern>(([color, pattern]) => ({ color, pattern }))(xprod(colors, patterns))
  const availablePatterns = difference<CardPattern>(
    cardPatterns,
    Object.values(room.users).map((user) => user.pattern)
  );
  if (availablePatterns.length === 0) {
    return getRandomListElement(cardPatterns);
  }
  return getRandomListElement(availablePatterns);
};

export const createPattern = ({ color, pattern }: CardPattern) =>
  patternGenerator[pattern](color);
